// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__1Tv64","label":"CategoryService_label__2T7sR","location":"CategoryService_location__32WTW"};